import { FC, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';
import { useProfile } from 'utils/helpers';

const SSO: FC = () => {
  const { setProfile } = useProfile();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const role = searchParams.get('role');
    const _token = searchParams.get('_token');
    const _sessionId = searchParams.get('_sessionId');
    const _isEmailAddressVerified = searchParams.get('_isEmailAddressVerified');
    const _isOnboarded = searchParams.get('_isOnboarded');
    const onboardingSteps = searchParams.get('_onboardingSteps');
    const loginValidated = searchParams.get('loginValidated');

    if (
      !role ||
      !_token ||
      !_sessionId ||
      !_isEmailAddressVerified ||
      !_isOnboarded ||
      !loginValidated
    ) {
      window.location.href = '/';

      return;
    }

    const _onboardingSteps = {} as any;

    if (onboardingSteps) {
      onboardingSteps
        .slice(1, -1)
        .split(',\n')
        .forEach((prop) => {
          const [key, value] = prop.split(': ');
          _onboardingSteps[key.trim()] = value.trim().replace(/'/g, '');
        });

      // convert the steps 'true' to boolean
      _onboardingSteps.step1 = _onboardingSteps.step1 === 'true';
      _onboardingSteps.step2 = _onboardingSteps.step2 === 'true';
      _onboardingSteps.step3 = _onboardingSteps.step3 === 'true';
      _onboardingSteps.step4 = _onboardingSteps.step4 === 'true';
    }

    let profile = {
      role,
      _token,
      _sessionId,
      _isEmailAddressVerified: _isEmailAddressVerified === 'true',
      _isOnboarded: _isOnboarded === 'true',
      loginValidated: loginValidated === 'true',
    } as any;

    if (Object.keys(_onboardingSteps).length)
      profile = { ...profile, _onboardingSteps };

    setProfile({
      profile,
    });

    window.location.href = '/';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

// eslint-disable-next-line react-refresh/only-export-components
export default SSO;
